import React from "react";
import { connect } from "react-redux";

import _notif from "../../logic/notification";
import { notifSelectors } from "../../logic/rootSelectors";
import { NOTIF_TYPE } from "../../utils/stateTypes";
import Snackbar from "./Snackbar";

const Notification = ({ notification, removeCallback }) => {
  return (
    <Snackbar
      openOverride={notification !== null}
      message={notification ? notification.text : ""}
      onCloseOverride={removeCallback}
      isSuccess={(notification !== null) && (notification.type === NOTIF_TYPE.SUCCESS)}
      isError={(notification !== null) && (notification.type === NOTIF_TYPE.ERROR)}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    notification: notifSelectors.getLatestNotification(state),
  };
};

export default connect(
  mapStateToProps,
  //Shorthand mapDispatchToProps
  { removeCallback: _notif.actions.removeNotification },
)(Notification);
